import { render, staticRenderFns } from "./ReportingFaculty.vue?vue&type=template&id=157a00c7&scoped=true"
import script from "./ReportingFaculty.vue?vue&type=script&lang=js"
export * from "./ReportingFaculty.vue?vue&type=script&lang=js"
import style0 from "./ReportingFaculty.vue?vue&type=style&index=0&id=157a00c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157a00c7",
  null
  
)

export default component.exports